// extracted by mini-css-extract-plugin
export default {"ContactUsPage":"ContactUsPage_ContactUsPage__7+YDi","mainBlock":"ContactUsPage_mainBlock__CPxsQ","title":"ContactUsPage_title__UCcU-"};